import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import VideocamOutlined from '@mui/icons-material/VideocamOutlined';

type CalendarSessionCueSource = {
  modality?: 'in_person' | 'video' | 'audio' | null;
  telehealth?: boolean | null;
  use_jotmeet?: boolean | null;
};

type SessionCueIcon = typeof VideocamOutlined;

export interface CalendarSessionCue {
  Icon: SessionCueIcon;
  label: string;
  modality: 'video' | 'audio';
  useJotMeet: boolean;
}

export const getCalendarSessionCue = (
  appointment: CalendarSessionCueSource,
): CalendarSessionCue | null => {
  const modality = appointment.modality ?? (appointment.telehealth ? 'video' : null);

  if (modality === 'audio') {
    return {
      Icon: PhoneOutlined,
      label: 'Phone visit',
      modality,
      useJotMeet: false,
    };
  }

  if (modality === 'video') {
    const useJotMeet = appointment.use_jotmeet === true;
    return {
      Icon: VideocamOutlined,
      label: useJotMeet ? 'JotMeet video visit' : 'Video visit',
      modality,
      useJotMeet,
    };
  }

  return null;
};
